import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BarraSuperior.css";
import logoBackground from "../Assets/logo.jpeg";
import { useData } from "../Pages/DataContext";
import NavigationIcon from "./NavigationIcon";
import {
  clearNavigationRole,
  getRoleNavigation,
  rememberNavigationRole,
} from "../../config/roleNavigation";

const BarraSuperior = ({ texto_cabecera }) => {
  const {
    data,
    setCarpetaId,
    setClaseData,
    setData,
    setDataAlumno,
    setUserId,
  } = useData();
  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const navigation = getRoleNavigation(data?.rol, location.pathname);
  const userName =
    data?.nombre && data?.apellido
      ? `${data.nombre} ${data.apellido}`
      : data?.nombre || "Usuario";

  useEffect(() => {
    rememberNavigationRole(data?.rol);
  }, [data?.rol]);

  useEffect(() => {
    const closeMenu = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    };

    const closeMenuWithEscape = (event) => {
      if (event.key === "Escape") {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", closeMenu);
    document.addEventListener("keydown", closeMenuWithEscape);

    return () => {
      document.removeEventListener("mousedown", closeMenu);
      document.removeEventListener("keydown", closeMenuWithEscape);
    };
  }, []);

  const navigateTo = (path) => {
    setIsUserMenuOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    clearNavigationRole();
    setData(undefined);
    setUserId(undefined);
    setClaseData(undefined);
    setCarpetaId(undefined);
    setDataAlumno(null);
    navigate("/");
  };

  return (
    <div
      className="barra-superior"
      style={{ "--role-accent": navigation.accent }}
    >
      <div className="barra-superior-contenedor-izquierdo">
        <button
          aria-label={`Ir al inicio de ${navigation.label}`}
          className="barra-superior-logo"
          onClick={() => navigateTo(navigation.home)}
          type="button"
        >
          <img src={logoBackground} alt="Grupo Derecho y Progreso" />
        </button>

        <button
          className="barra-superior-home"
          onClick={() => navigateTo(navigation.home)}
          type="button"
        >
          <NavigationIcon name="home" size={22} />
          <span>Inicio</span>
        </button>

        <div className="barra-superior-contexto">
          <span className="barra-superior-role">{navigation.label}</span>
          {texto_cabecera && <p title={texto_cabecera}>{texto_cabecera}</p>}
        </div>
      </div>

      <div className="barra-superior-contenedor-derecho" ref={menuRef}>
        <button
          aria-expanded={isUserMenuOpen}
          aria-haspopup="menu"
          className="barra-superior-user"
          onClick={() => setIsUserMenuOpen((isOpen) => !isOpen)}
          type="button"
        >
          <span className="barra-superior-avatar">
            <NavigationIcon name="profile" size={23} />
          </span>
          <span className="barra-superior-user-copy">
            <strong>{userName}</strong>
            <small>{navigation.label}</small>
          </span>
          <NavigationIcon
            className={`barra-superior-chevron${
              isUserMenuOpen ? " barra-superior-chevron-open" : ""
            }`}
            name="chevron"
            size={18}
          />
        </button>

        {isUserMenuOpen && (
          <div className="barra-superior-menu" role="menu">
            <button
              onClick={() => navigateTo(navigation.profile)}
              role="menuitem"
              type="button"
            >
              <NavigationIcon name="profile" size={19} />
              <span>Ver perfil</span>
            </button>
            <button
              className="barra-superior-logout"
              onClick={handleLogout}
              role="menuitem"
              type="button"
            >
              <NavigationIcon name="logout" size={19} />
              <span>Cerrar sesión</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BarraSuperior;
